import React from "react";
import { connect } from "react-redux";
import { guardarDatosPoliza } from "./flujo.act";
import PolizaForm from "./poliza.frm";
import PolizaMovileFrom from './poliza.movil.frm';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		poliza_valida: state.registro.configuracion.poliza_valida,
		poliza_padre: state.registro.configuracion.poliza_padre,
		fchVigInicial: state.registro.configuracion.fchVigInicial,
		referencia: state.registro.configuracion.referencia,
		sistema: state.registro.configuracion.sistema,
		dispositivo: state.global.dispositivo
	};
};


const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		pasoSiguiente: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		},
		pasoAnterior: () => {
			dispatch({ "type": "REGISTRO_PASO_ANTERIOR" });
		},
		registrarDatos(sRamo, sPoliza, sPolizaHija, sReferencia, sFchVigInicial, sInicioVigencia, sInicioVigenciaDate, sCertificado, 
			sPlacas, sMotor, rfcbnmx, polizaBanamex, fechaDeNacimiento, fechaDeNacimientoDate, codFiliacion, idParticipante, apaterno, 
			amaterno, nombres, avisoAceptado, mediosElectronicos) {
			dispatch(guardarDatosPoliza(sRamo, sPoliza, sPolizaHija, sReferencia, sFchVigInicial, sInicioVigencia, sInicioVigenciaDate, 
				sCertificado, sPlacas, sMotor, rfcbnmx, polizaBanamex, fechaDeNacimiento, fechaDeNacimientoDate, codFiliacion, 
				idParticipante, apaterno, amaterno, nombres, avisoAceptado, mediosElectronicos));
		}
	};
};

class Poliza extends React.Component {

	submit = (data) => {
		let $this = this;
		let poliza_hija = (this.props.poliza_padre) ? this.props.poliza_valida : false;
		let fchVigInicial = (this.props.poliza_padre) ? this.props.fchVigInicial : false;
		let referencia = (this.props.referencia) ? this.props.referencia : false;

		if (this.props.sistema == "INFO") {
			while (data.poliza.length < 14) {
				data.poliza = "0" + data.poliza;
			}
		}
		if (data.polizaReal && parseInt(data.poliza) !== parseInt(data.polizaReal)) {
			data.poliza = data.polizaReal;
		}

		console.log("Poliza: " + data.poliza);
		$this.props.loader(true);
		return new Promise(resolve => {
			$this.props.registrarDatos(
				data.ramo,
				data.poliza,
				poliza_hija,
				referencia,
				fchVigInicial,
				data.inicioVigenciaPoliza,
				data.inicioVigenciaPolizaDate,
				data.certificado,
				data.placas,
				data.motor,
				data.rfcbnmx,
				data.polizaBanamex,
				data.fechaDeNacimiento,
				data.fechaDeNacimientoDate,
				data.codFiliacion,
				data.idParticipante,
				data.apaterno,
				data.amaterno,
				data.nombres,
				data.avisoAceptado,
				data.mediosElectronicos
			);
			$this.props.pasoSiguiente();
			$this.props.loader(false);
			resolve();
		});
	}

	render() {
		console.log("isDispositivoPulled?", this.props.dispositivo)
		const { dispositivo } = this.props;
		return (
			dispositivo === "app" ?
				<PolizaMovileFrom onSubmit={this.submit} /> :
				<PolizaForm onSubmit={this.submit} />
		)
	}
}

export default connect(mapState, mapDispatch)(Poliza);



// WEBPACK FOOTER //
// ./src/gnp-registro/poliza.cmpt.js